import { Modal } from "components";
import moment from "moment";
import React from "react";
import { useLocalStorage } from "utilities/usehooks";

interface Props {
  visibleFrom: moment.Moment;
  visibleUntil: moment.Moment;
  title: string;
  imageUrl: string;
  learnMoreUrl?: string;
  id: string;
}

export const NewFeatureAdModal = (props: Props) => {
  const [visible, setVisible] = useLocalStorage(`announcement:${props.id}`, true);

  const currentTime = moment.utc();
  const isVisible = visible && currentTime.isAfter(props.visibleFrom) && currentTime.isBefore(props.visibleUntil);

  return <Modal
    isOpen={isVisible}
    handleClose={() => setVisible(false)}
    title={props.title}
    displayHeader={false}
    width="fit-content"
  >
    <a href={props.learnMoreUrl} style={{
      cursor: props.learnMoreUrl ? "pointer" : "default",
    }} className="new-feature-add-wrapper" target="_blank" rel="noopener noreferrer">
      <img src={props.imageUrl} className="new-feature-add-image" />
    </a>
  </Modal>
}